import { gql } from '@apollo/client';

export type EventGQLType = {
  name: string;
  startDateTime: string;
  endDateTime: string;
  calendarSource: string;
  type: 'Game' | 'Practice';
  seasonFullName: string;
  division: {
    id: number;
    name: string;
  };
  location: {
    name: string;
    venueName: string;
    fullAddress: string;
    
  };
  linkInfo: {
    eventId: string;
    teamId: string;
    divisionId: string;
    scheduleItemId: string;
  };
  teams: {
    teamName: string;
  }[];
};

const QUERY = gql`
  query CalendarEvents(
    $organizationId: ID!
    $startDateTime: String
    $endDateTime: String
    $seasonIds: [Int]
    $divisionIds: [ID]
    $locationIds: [ID]
    $teamIds: [ID]
    $calendarSources: [String]
  ) {
    calendarEvents(
      filter: {
        organizationId: $organizationId
        startDateTime: $startDateTime
        endDateTime: $endDateTime
        seasonIds: $seasonIds
        divisionIds: $divisionIds
        locationIds: $locationIds
        teamIds: $teamIds
        calendarSources: $calendarSources
      }
    ) {
      endDateTime
      seasonId
      seasonName
      seasonFullName
      type
      calendarSource
      startDateTime
      calendarSource
      name
      teams {
        teamName
      }
      division {
        id
        name
      }
      location {
        name
        venueName
        fullAddress
      }
      linkInfo {
        eventId
        teamId
        divisionId
        scheduleItemId
      }
    }
  }
`;

export default QUERY;
